<template>
    <div class="winnow-view">
        <img class="big-img" :src="bigImg" alt="">
        <div class="hidden-view">
            <div ref="itemsView" class="winnow-box">
                <winnowItemView v-for="(item,index) in contents" :item="item" :key="index">
                </winnowItemView>
            </div>
        </div>
    </div>
</template>

<script>
    import winnowItemView from "../winnowItemView/winnowItemView.vue";
    export default {
        name: "winnowView",
        props: ["bigImg", "contents"],
        components: {
            winnowItemView
        },
        created() {
            console.log("winnow組件創建完成");
        },
        beforeUpdate() {
            var temp = this.contents.length * (100 + 10);
            this.$refs.itemsView.style.width = temp + "px";
            console.log("設置寬度");
        }
        //下面方法會導致組件先呼叫，資料後呼叫問題
        // mounted() {
        //   //獲得對應 winnow-box節點,動態設置寬度
        //   var temp = this.contents.length * (100 + 10);
        //   this.$refs.itemsView.style.width = temp + "px";
        // }
    };
</script>

<style lang="scss">
    .winnow-view {
        .big-img {
            width: 100%;
        }
        .hidden-view {
            width: 100%;
            overflow-y: auto;
        }
        .winnow-box {
            background-color: white;
            overflow: hidden;
            padding-left: 10px;
        }
    }
</style>
>